/**
 * Human-readable connection-type badge for a People-list row, from the
 * user's self-reported WebRTC transport summary. Undefined (hide the badge)
 * when there is no data — an old client, or no WebRTC connections yet.
 */
export function formatConnectionTypeLabel(summary) {
    if (summary === undefined) {
        return undefined;
    }
    const total = summary.webrtcDirectConnectionCount +
        summary.webrtcRelayConnectionCount;
    if (total === 0) {
        return undefined;
    }
    if (summary.webrtcRelayConnectionCount === 0) {
        return 'direct';
    }
    if (summary.webrtcDirectConnectionCount === 0) {
        return 'TURN relay';
    }
    return `mixed (${summary.webrtcRelayConnectionCount}/${total} relayed)`;
}
